/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "ACLManagementNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "PollCreationNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "PollManagementNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "VoteNotAllowed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "canCreatePoll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "ProposalId",
                name: "proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "canManagePoll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "ProposalId",
                name: "proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "canVoteOnPoll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "dao",
                type: "address",
            },
            {
                internalType: "ProposalId",
                name: "proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "creator",
                type: "address",
            },
        ],
        name: "onPollCreated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
export class PollACLv1__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
PollACLv1__factory.abi = _abi;
//# sourceMappingURL=PollACLv1__factory.js.map